import React__default from 'react';
import { useStyles } from '@sravni/react-utils';
import { contentWidgetParam } from '../../../consts/links.js';
import { decorateRelativeUrlByDomain, makeRelAttribute } from '../../../utils/links.js';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import modules_973b0c03 from '../styles/HiddenLinks.module.less.js';

const HiddenLinks = (props) => {
    const { menu, hideTopLinks } = props;
    const cx = useStyles(modules_973b0c03);
    const { domains } = useCustomProps();
    return (React__default.createElement("div", { className: cx('hiddenLinks') }, menu.map((topLink) => {
        if (!topLink.href) {
            return null;
        }
        const { isLink, text, href } = topLink;
        const hasWidget = topLink.href.includes(contentWidgetParam);
        return (React__default.createElement(React__default.Fragment, { key: `${topLink.text}-top` },
            hideTopLinks && isLink && (React__default.createElement("a", { href: domains?.base ? decorateRelativeUrlByDomain(href, domains.base) : href, rel: makeRelAttribute(topLink) }, text)),
            topLink.children?.slice(0, hasWidget ? 2 : undefined).map((group) => {
                if (!group.children) {
                    return null;
                }
                return (React__default.createElement(React__default.Fragment, { key: `${group.text}-group` }, group.children.map((item) => {
                    const { text, href } = item;
                    if (!href) {
                        return null;
                    }
                    return (React__default.createElement("a", { key: text, href: domains?.base ? decorateRelativeUrlByDomain(href, domains.base) : href, rel: makeRelAttribute(item) }, text));
                })));
            })));
    })));
};

export { HiddenLinks };
//# sourceMappingURL=HiddenLinks.js.map
